module.exports = __webpack_public_path__ + "img/atari1200_page14.ba5f2e23.jpg";